/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let Ascending: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M796.128256 345.342976l-67.332096 67.331072c-16.662528 16.662528-43.677696 16.662528-60.3392 0-16.662528-16.661504-16.662528-43.676672 0-60.3392l136.63744-136.63744c5.884928-7.56736 14.26432-13.101056 23.902208-15.366144 14.06976-3.529728 29.58848 0.206848 40.592384 11.210752 10.19392 10.19392 14.15168 24.261632 11.872256 37.464064v533.305344c0 23.564288-19.10272 42.667008-42.665984 42.667008-23.564288 0-42.667008-19.10272-42.667008-42.667008V345.344z m-611.555328-91.275264h369.77664c23.565312 0 42.667008 19.10272 42.667008 42.667008s-19.101696 42.667008-42.665984 42.667008H184.572928c-23.564288 0-42.667008-19.10272-42.667008-42.667008s19.10272-42.667008 42.667008-42.667008z m0 227.556352h369.77664c23.565312 0 42.667008 19.101696 42.667008 42.665984 0 23.564288-19.101696 42.667008-42.665984 42.667008H184.572928c-23.564288 0-42.667008-19.10272-42.667008-42.667008s19.10272-42.665984 42.667008-42.665984z m0 227.555328h369.77664c23.565312 0 42.667008 19.10272 42.667008 42.665984 0 23.564288-19.101696 42.667008-42.665984 42.667008H184.572928c-23.564288 0-42.667008-19.10272-42.667008-42.667008 0-23.563264 19.10272-42.665984 42.667008-42.665984z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

Ascending.defaultProps = {
  size: 18,
};

Ascending = React.memo ? React.memo(Ascending) : Ascending;

export default Ascending;
